export default "__VITE_ASSET__C$nU6epj__"